import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-zinc-900 py-12" data-id="element-86">
      <div className="container mx-auto px-4 text-center" data-id="element-87">
        <div className="mb-8" data-id="element-88">
          <p className="text-zinc-400 font-medium mb-2" data-id="element-89">
            PRODUCTO DIGITAL · Acceso inmediato · Descarga en PDF · Acceso de
            por vida
          </p>
        </div>

        <div className="text-zinc-600 text-sm mb-6" data-id="element-90">
          <p data-id="element-91">
            © 2024 Código Asado: El Sistema Maestro Centenario. Todos los
            derechos reservados.
          </p>
        </div>

        <div className="flex justify-center gap-6 text-sm text-zinc-500 mb-8" data-id="element-92">
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-93">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-94">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-95">
            Contacto
          </a>
        </div>

        <p className="text-zinc-700 text-xs max-w-2xl mx-auto" data-id="element-96">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}